export const REDIRECT_NO_LONGER_AVAILABLE =
  "We don't seem to have that product anymore, but here are some similar items below.";

export const DELIVERY_QUICK_FILTERS_TITLE = 'Quick filters';
